// extracted by mini-css-extract-plugin
export default {"Tooltip":"Tooltip_Tooltip__9mCxS","Popper":"Tooltip_Popper__ZOgnM"};